import { render, staticRenderFns } from "./MFAEnrollment.vue?vue&type=template&id=afaad8b2"
import script from "./MFAEnrollment.vue?vue&type=script&lang=js"
export * from "./MFAEnrollment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports